import { GTMEventCategories } from '@mafc/common';
import { getUserGTMProps } from './gtm.utils';
import { GTMEvents } from 'constants/gtm.constants';

declare var dataLayer: any;

abstract class TrackerSubstitution {
  static shipmentReplaceBtnTracking() {
    const userProps = getUserGTMProps();

    dataLayer.push({
      event: GTMEvents.custom_event,
      event_action: 'replace_button_clicked_on_cart',
      event_category: GTMEventCategories.user_engagement,
      event_label: 'cta_replace_clicked',
      screen_name: 'cart',
      screen_type: 'cart',
      ga4: 'true',
      ...userProps,
    });
  }

  static selectSubstituteReplaceBtnTracking() {
    const userProps = getUserGTMProps();

    dataLayer.push({
      event: GTMEvents.custom_event,
      event_action: 'replace_button_clicked_on_replacement_screen',
      event_category: GTMEventCategories.user_engagement,
      event_label: 'cta_replace_clicked',
      screen_name: 'replacement',
      screen_type: 'cart',
      ga4: 'true',
      ...userProps,
    });
  }

  static chooseSubstituteSkipBtnTracking() {
    const userProps = getUserGTMProps();

    dataLayer.push({
      event: GTMEvents.custom_event,
      event_action: 'skip_button_clicked_on_replacement_screen',
      event_category: GTMEventCategories.user_engagement,
      event_label: 'cta_skip_clicked',
      screen_name: 'replacement',
      screen_type: 'cart',
      ga4: 'true',
      ...userProps,
    });
  }

  static chooseSubstituteATCBtnTracking() {
    const userProps = getUserGTMProps();

    dataLayer.push({
      event: GTMEvents.custom_event,
      event_action: 'ATC_button_clicked_on_replacement_screen',
      event_category: GTMEventCategories.user_engagement,
      event_label: 'cta_ATC_clicked',
      screen_name: 'replacement',
      screen_type: 'cart',
      ga4: 'true',
      ...userProps,
    });
  }

  static replacementAvailableTracking() {
    const userProps = getUserGTMProps();

    dataLayer.push({
      event: GTMEvents.custom_event,
      event_action: 'OOS_msg_view',
      event_category: GTMEventCategories.user_engagement,
      event_label: 'OOS_msg_replacement_available',
      screen_name: 'cart',
      screen_type: 'cart',
      ga4: 'true',
      ...userProps,
    });
  }

  static fetchSubstituteFailureTracking() {
    const userProps = getUserGTMProps();

    dataLayer.push({
      event: GTMEvents.custom_event,
      event_action: 'OOS_msg_view',
      event_category: GTMEventCategories.user_engagement,
      event_label: 'OOS_msg_view_replacement_unavailable_API_failure',
      screen_name: 'cart',
      screen_type: 'cart',
      ga4: 'true',
      ...userProps,
    });
  }
}

export default TrackerSubstitution;
